import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from "@tanstack/react-query";
import {
  getMarketingResourceTopics,
  getMarketingResources,
} from "../api/resource";
import {
  GetMarketingResourceTopicsParams,
  GetMarketingResourcesParams,
} from "../types";

export const marketingResourcesQueryOptions = (
  variables: GetMarketingResourcesParams = {},
  { enabled = true }: { enabled?: boolean } = {}
) =>
  queryOptions({
    queryKey: ["marketing-resources", variables],
    queryFn: () => getMarketingResources(variables),
    placeholderData: keepPreviousData,
    enabled,
  });

export function useMarketingResources(
  variables: GetMarketingResourcesParams = {},
  { enabled = true }: { enabled?: boolean } = {}
) {
  return useQuery({
    ...marketingResourcesQueryOptions(variables, { enabled }),
    select: (data) => data.results,
  });
}

export function usePaginatedMarketingResources(
  variables: GetMarketingResourcesParams = {},
  { enabled = true }: { enabled?: boolean } = {}
) {
  return useQuery(marketingResourcesQueryOptions(variables, { enabled }));
}

export const marketingResourceTopicsQueryOptions = (
  variables: GetMarketingResourceTopicsParams = {},
  { enabled = true }: { enabled?: boolean } = {}
) =>
  queryOptions({
    queryKey: ["marketing-resource-topics", variables],
    queryFn: () => getMarketingResourceTopics(variables),
    enabled,
  });

export function useMarketingResourceTopics(
  variables: GetMarketingResourceTopicsParams = {},
  { enabled = true }: { enabled?: boolean } = {}
) {
  return useQuery(marketingResourceTopicsQueryOptions(variables, { enabled }));
}
